'use client';

import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const ClockContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Clock = styled.div`
  position: relative;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 1rem;
  border: solid 0.375rem black;
`;

export const Hours = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  transform: translate(-50%, -50%);
  transform-origin: 0 center;
  animation: ${spin} 5s linear infinite;

  &::before {
    content: '';
    display: block;
    height: 0.375rem;
    width: 1.25rem;
    background: ${(props) => props.theme.colors.brand};
    border-radius: 0.1875rem;
    position: absolute;
    left: 0;
    top: -0.1875rem;
  }
`;

export const Minutes = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  transform: translate(-50%, -50%);
  transform-origin: 0 center;
  animation: ${spin} 0.41s linear infinite;

  &::before {
    content: '';
    display: block;
    height: 0.375rem;
    width: 1.75rem;
    background: ${(props) => props.theme.colors.brand};
    border-radius: 0.1875rem;
    position: absolute;
    left: 0;
    top: -0.1875rem;
  }
`;
